module.exports = __webpack_public_path__ + "assets/img/qrcode-wx-4aa1bebc.jpg";